import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";
import { Form } from "@circle-react-uikit/Form";
import { FileTypeSelect } from "./FileTypeSelect";

interface TranscriptFormBodyProps {
  aiFileDownloadUrl: string;
  isUpdating: boolean;
  supportsAi: boolean;
}

const translationRoot = "media_player.transcript_menu";

export const TranscriptFormBody = ({
  isUpdating,
  supportsAi,
  aiFileDownloadUrl,
}: TranscriptFormBodyProps) => {
  const { watch } = useFormContext();
  const isEnabled = watch("enabled") as boolean;
  const validateSelectedFile = (selectedFileValue: string) => {
    if (selectedFileValue === "ai" && !supportsAi) {
      return t("media_player.transcript_menu.file_type.ai_not_supported_error");
    }
    return true;
  };

  return (
    <>
      <Form.Item
        name="enabled"
        translationRoot={translationRoot}
        hideBorder
        fullWidth
        inline
        className="!p-0"
        isDisabled={isUpdating}
      >
        <Form.ToggleSwitch variant="small" name="enabled" />
      </Form.Item>
      {isEnabled && (
        <Form.Item
          name="selected_file"
          translationRoot={translationRoot}
          hideBorder
          fullWidth
          inline
          hideLabel
          hideDescription
          isDisabled={isUpdating}
          rules={{
            validate: validateSelectedFile,
          }}
          className="flex flex-col"
        >
          <FileTypeSelect
            name="selected_file"
            rules={{
              validate: validateSelectedFile,
            }}
            supportsAi={supportsAi}
            aiFileDownloadUrl={aiFileDownloadUrl}
          />
        </Form.Item>
      )}
      <div className="flex justify-end">
        <Button
          type="submit"
          variant="circle"
          disabled={isUpdating}
          className="mt-1"
        >
          {t("save")}
        </Button>
      </div>
    </>
  );
};
